@if (currentFicheConseil?.natureOperation?.id === NatureOperationId.Souscription) {
<div class="flex-vertical background-white width-100pc oui-elevation-04 rounded padding-32 gap-48 card">
  <div class="flex-vertical gap-8">
    <h6>Versement</h6>
  </div>
  <div class="flex-vertical gap-48">
    <oui-slide-toggle
      label="Mise en place de versements programmés"
      [control]="slideVpControl"
      *ngIf="slideVpControl.isVisible()"></oui-slide-toggle>
    <oui-slide-toggle
      label="Souscription avec transfert"
      [control]="slideTransfertControl"
      *ngIf="slideTransfertControl.isVisible()"></oui-slide-toggle>
  </div>
  <div class="flex-vertical gap-24">
    <div class="subtitle-1">Versement initial</div>
    <div class="oui-form-line">
      <oui-textfield
        label="Montant Brut"
        type="number"
        textSuffix="€"
        (input)="onMontantInput($event)"
        class="oui-form-field-md"
        [min]="0"
        [control]="viMontantBrutControl"
        [errors]="viMontantErrors"></oui-textfield>
      <oui-textfield
        label="Frais de versement"
        type="number"
        textSuffix="%"
        class="oui-form-field-md"
        [min]="0"
        [hint]="fraisViHint"
        [step]="0.1"
        [control]="viFraisVersementControl"
        [errors]="viTauxErrors"></oui-textfield>
    </div>
    <div class="flex-vertical gap-24" *ngIf="slideVpControl?.value">
      <div class="subtitle-1">Versements programmés</div>
      <oui-select
        [control]="vpFrequenceControl"
        [options]="vpFrequenceOptions"
        label="Fréquence"
        [errors]="requiredValueError"
        *ngIf="vpFrequenceControl"></oui-select>
      <div class="oui-form-line">
        <oui-textfield
          label="Montant Brut"
          type="number"
          (input)="onMontantInput($event)"
          textSuffix="€"
          class="oui-form-field-md"
          [min]="0"
          [control]="vpMontantBrutControl"
          [errors]="viMontantErrors"
          *ngIf="vpMontantBrutControl"></oui-textfield>
        <oui-textfield
          label="Frais de versement"
          type="number"
          textSuffix="%"
          class="oui-form-field-md"
          [hint]="fraisViHint"
          [min]="0"
          [step]="0.1"
          [control]="vpFraisVersementControl"
          [errors]="vpTauxErrors"
          *ngIf="vpFraisVersementControl"></oui-textfield>
      </div>
    </div>
  </div>
</div>
} @else {
<div class="flex-vertical gap-32">
  <div class="flex-vertical background-white width-100pc oui-elevation-04 rounded padding-32 gap-48">
    <h6>Versement complémentaire</h6>
    <div class="flex-vertical gap-24">
      <div class="oui-form-line">
        <oui-textfield
          label="Montant Brut"
          type="number"
          (input)="onMontantInput($event)"
          textSuffix="€"
          class="oui-form-field-md"
          [min]="0"
          [control]="vcMontantBrutControl"
          [errors]="vcMontantErrors"
          *ngIf="vcMontantBrutControl"></oui-textfield>
        <oui-textfield
          label="Frais de versement"
          type="number"
          textSuffix="%"
          class="oui-form-field-md"
          [hint]="fraisVcHint"
          [min]="0"
          [step]="0.1"
          [control]="vcFraisVersementControl"
          [errors]="vcTauxErrors"
          *ngIf="vcFraisVersementControl"></oui-textfield>
      </div>
    </div>
  </div>
  <div
    class="flex-vertical background-white width-100pc oui-elevation-04 rounded padding-32 gap-48"
    *ngIf="avecMiseEnPlaceOuModificationVP?.value">
    <div class="flex-vertical gap-24">
      <h6>Versements programmés</h6>
      <oui-button-toggle [options]="vpModeOptions" [control]="vpModeControl"></oui-button-toggle>
      <ng-container *ngIf="vpModeControl?.value && vpModeControl?.value === VpModeOptions.MiseEnPlace">
        <oui-select
          [control]="vpFrequenceControl"
          [options]="vpFrequenceOptions"
          label="Fréquence"
          [errors]="requiredValueError"
          *ngIf="vpFrequenceControl"></oui-select>
        <div class="oui-form-line">
          <oui-textfield
            label="Montant Brut"
            type="number"
            (input)="onMontantInput($event)"
            textSuffix="€"
            class="oui-form-field-md"
            [min]="0"
            [control]="vpMontantBrutControl"
            [errors]="vpMontantErrors"
            *ngIf="vpMontantBrutControl"></oui-textfield>
          <oui-textfield
            label="Frais de versement"
            type="number"
            textSuffix="%"
            class="oui-form-field-md"
            [hint]="fraisVpHint"
            [min]="0"
            [step]="0.1"
            [control]="vpFraisVersementControl"
            [errors]="vpTauxErrors"
            *ngIf="vpFraisVersementControl"></oui-textfield>
        </div>
      </ng-container>
      <div class="flex-vertical gap-24" *ngIf="avecMiseEnPlaceOuModificationVP?.value">
        <ng-container *ngIf="vpModeControl?.value && vpModeControl?.value === VpModeOptions.Modification">
          <div class="body-1 flex-vertical bold">
            <div class="flex-horizontal align-horizontal-center">
              Sur quoi porte la modification ?<span class="color-error">*</span>
            </div>
          </div>
          <div class="body-2 flex-vertical" [ngClass]="{ 'color-error': !isStepValid() && stepTouched }">
            Sélectionnez au moins un choix :
          </div>
          <div class="oui-form-line width-100pc flex-horizontal align-horizontal-center">
            <oui-checkbox [control]="isVpFrequenceEditableControl"></oui-checkbox>
            <oui-select
              class="width-100pc"
              [control]="vpFrequenceControl"
              [options]="vpFrequenceOptions"
              label="Fréquence"
              [errors]="requiredValueError"
              *ngIf="vpFrequenceControl"></oui-select>
          </div>
          <div class="oui-form-line width-100pc flex-horizontal align-horizontal-center">
            <oui-checkbox [control]="isVpMontantBrutEditableControl"></oui-checkbox>
            <oui-textfield
              label="Montant Brut"
              type="number"
              (input)="onMontantInput($event)"
              textSuffix="€"
              class="width-100pc"
              [min]="0"
              [control]="vpMontantBrutControl"
              [errors]="vpMontantErrors"
              *ngIf="vpMontantBrutControl"></oui-textfield>
          </div>
          <div class="oui-form-line width-100pc flex-horizontal align-horizontal-frais-center">
            <oui-checkbox [control]="isVpFraisVersementEditableControl"></oui-checkbox>
            <oui-textfield
              label="Frais de versement"
              type="number"
              textSuffix="%"
              class="width-100pc"
              [hint]="fraisVpHint"
              [min]="0"
              [step]="0.1"
              [control]="vpFraisVersementControl"
              [errors]="vpTauxErrors"
              *ngIf="vpFraisVersementControl"></oui-textfield>
          </div>
          <oui-checkbox
            (checkedChange)="onChangementAllocationToggle($event)"
            [control]="avecChangementAllocationControl"
            label="Changement d'allocation"></oui-checkbox>
          <oui-checkbox
            [control]="avecChangementCoordonneesBancairesControl"
            label="Changement de coordonnées bancaires"></oui-checkbox>
        </ng-container>
      </div>
    </div>
  </div>
</div>
}
